import React from 'react';
import Hero from '../components/landlord/Hero';
import Subscribe from '../UI/subscribe';
import WhyFms from '../components/landlord/WhyFms';
import AllOnePlace from '../components/landlord/AllOnePlace';

const Landlord = () => {
    const data = {
        title: "Ready to Manage Properties Without the Headache?",
        btnText: "Get Started"
    }
    
  return (
    <div>
      <Hero/>
      <AllOnePlace/>
      <WhyFms/>
      <Subscribe data={data}/>
    </div>
  );
};

export default Landlord;
